/* eslint-disable @typescript-eslint/no-explicit-any */

import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { doNothing } from '../../helpers/functions/doNothing'
import { Module } from '../../helpers/types'
import type {
  LinkWithData,
  Asset,
  OnShowAssetPickerProps,
  OnLinkDataUpdate,
} from '../../helpers/types'
import { Stream, Single } from './displays'
import { baseStyles } from './styles'

interface Props {
  accountImage: Asset | null
  accountName: string
  accountUsername: string
  assets?: Asset[]
  content: string
  display: string
  index?: number
  isAccountPremium?: boolean
  isPresenting: boolean
  isThreaded?: boolean
  linksWithData?: LinkWithData[]
  modules?: Module[]
  onExpandAsset?: () => void
  onRemoveAsset?: () => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  postType: string
  readOnly: boolean
  scheduledAt: string
  timezone: string
  updateAssets?: (assets: AssetReference[]) => void
  updateCaption?: () => void
  updateLinkData?: OnLinkDataUpdate
  updateText?: (val: string, destination: string) => void
}

const displays: { [key: string]: React.FC<any> } = {
  mobileStream: Stream,
  desktopStream: Stream,
  mobileSingle: Single,
  desktopSingle: Single,
  default: Single,
}

const matchDisplay = (display: string): React.FC<any> =>
  displays[display] || displays.default

export const TwitterTweet: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  assets,
  content,
  display,
  index,
  isAccountPremium,
  isPresenting,
  isThreaded,
  linksWithData,
  modules,
  onExpandAsset,
  onShowAssetPicker,
  updateLinkData,
  onRemoveAsset,
  postType,
  readOnly,
  scheduledAt,
  timezone,
  updateAssets,
  updateCaption,
  updateText,
}) => {
  const RenderDisplay = matchDisplay(display)

  return (
    <div
      css={baseStyles(display, postType)}
      className={kuiperClassNames(
        'twitter twitter-tweet',
        `twitter-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        assets={assets || []}
        display={display}
        content={content}
        index={index || -1}
        isAccountPremium={isAccountPremium}
        isPresenting={isPresenting}
        isThreaded={isThreaded ? isThreaded : false}
        modules={modules || []}
        linksWithData={linksWithData || []}
        onAssetChange={
          updateAssets
            ? (val: AssetReference[]): void => updateAssets(val)
            : doNothing
        }
        onContentChange={
          updateText
            ? (val: string): void => updateText(val, 'content')
            : doNothing
        }
        onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
        onLinkDataUpdate={updateLinkData ? updateLinkData : doNothing}
        onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
        onShowAssetPicker={onShowAssetPicker ? onShowAssetPicker : doNothing}
        postType={postType}
        readOnly={readOnly}
        scheduledAt={scheduledAt}
        timezone={timezone}
        updateCaption={updateCaption ? updateCaption : doNothing}
      />
    </div>
  )
}
